import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import type { Tournament } from '@/data/types';
import { StatusBadge } from './index';

const FORMAT_LABEL_SHORT: Record<Tournament['format'], string> = {
  SINGLE_ELIM: 'Олимпийка',
  DOUBLE_ELIM: 'Двойная',
  ROUND_ROBIN: 'Круговая',
  SWISS: 'Швейцарка',
  GROUPS_PLAYOFF: 'Группы + плей-офф',
};

export function TournamentCard({ tournament }: { tournament: Tournament }) {
  const d = tournament.date.toDate();
  const day = d.getDate();
  const month = d.toLocaleDateString('ru-RU', { month: 'short' }).replace('.', '');

  return (
    <Link to={`/tournaments/${tournament.id}`} className="t-card">
      <div
        className="row gap-3"
        style={{ alignItems: 'flex-start', justifyContent: 'space-between' }}
      >
        <div style={{ minWidth: 0, flex: 1 }}>
          <div
            className="td-h2"
            style={{
              marginBottom: 6,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {tournament.name}
          </div>
          <div className="t-card-meta">
            <span>{FORMAT_LABEL_SHORT[tournament.format]}</span>
            <span>·</span>
            <span>{tournament.discipline === 'SINGLES' ? 'Одиночка' : 'Пары'}</span>
            <span>·</span>
            <span>{tournament.matchFormat}</span>
          </div>
        </div>
        <div style={{ textAlign: 'right', flexShrink: 0 }}>
          <div
            className="t-mono"
            style={{ fontSize: 22, fontWeight: 600, lineHeight: 1, letterSpacing: '-0.02em' }}
          >
            {day}
          </div>
          <div
            className="t-xs t-mute"
            style={{ marginTop: 2, textTransform: 'uppercase', letterSpacing: '0.05em' }}
          >
            {month}
          </div>
        </div>
      </div>
      <div className="t-card-foot">
        <div className="row gap-2">
          <Users size={14} style={{ color: 'var(--fg-soft)' }} />
          <span className="t-small t-mute t-mono">{tournament.participantCount}</span>
        </div>
        <StatusBadge status={tournament.status} />
      </div>
    </Link>
  );
}
